import { Component, OnInit, ViewChild, OnDestroy, NgZone } from '@angular/core';
import { authenticationService } from 'src/app/Services/Authentication/authentication.service';
import { ViewController, AlertInput } from '@ionic/core';
import { PopoverController, ModalController, NavParams, AlertController, IonContent, ActionSheetController, LoadingController } from '@ionic/angular';
import { FactoryService } from 'src/app/Services/historique/factory.service';
import { isUndefined } from 'util';
import { CotationIndivAccidentService } from 'src/app/Services/Cotation/cotationIndiv.service';
import { SharedService } from 'src/app/Services/sheared/sharedService.service';
import { CotationService } from 'src/app/Services/Cotation/cotation.service';
import { PaiesimulateComponent } from '../../paiesimulate/paiesimulate.component';
import { Subscription } from 'rxjs';
import { PaiementService } from 'src/app/Services/Paiement/paiement.service';
import { Router } from '@angular/router';
import { AssureurService } from 'src/app/Services/Assureur/assureur.service';
import { IonicSelectableComponent } from 'ionic-selectable';



@Component({
  selector: 'app-indivresumeprime',
  templateUrl: './indivresprime.component.html',
  styleUrls: ['./indivresprime.component.scss'],
})

export class IndivResPrimeComponent implements OnInit,OnDestroy {
  dtjr: string
  objetpass: any;
  itemsData: any[] = []
  private items: any[] = []
  select_Assureur: any = null;
  assureurs = [];
  selectedImage: string;
  fileList: string[] = []
  textImageselect: boolean
  isEnabled: boolean = false
  TypeObjet: string = ""
  afficheVoyage: boolean = false
  loading : HTMLIonLoadingElement
  options = {
    centeredSlides: true,
    loop: false,
    spaceBetween: -50,
  };


  @ViewChild(IonContent,{static:false}) content: IonContent
  constructor(    private modalCtrl: ModalController, private assureurService: AssureurService,
    private _sheard: SharedService,
    private auth: authenticationService,
    private alertController: AlertController,
    private loadingController: LoadingController,
    private _fact: FactoryService,
    private _cotationIndivAccidentService:CotationIndivAccidentService,
    private _primeService: PaiementService,
    private _route: Router, private ngZ: NgZone,
    private nvparms: NavParams) {



      this.objetpass = this.nvparms.get('value');
      this.objetpass.open=true
      this.objetpass.CodeAssur = this._fact.getData(201)
      this.dtjr = this._sheard.ConvertDMYorYMD(this._sheard.getDate());
      this.assureurService.getAssureurs();



  }
  onDetail(item) {

    item.open = !item.open;
  }
  ngOnDestroy(): void {
   
  }
  ngOnInit(): void {
    this.TypeObjet = 'INDIVIDUELLE'
    let timer=setTimeout(() => {
      if (this.objetpass.mois3) {
        this.itemsData.push({
          periode: this.objetpass.mois3,
          prime: this.objetpass.prime3,
          accessoire: this.objetpass.acc3,
          taxe: this.objetpass.Taxe3,
          css: this.objetpass.css3,
          primettc: this.objetpass.Ttc3,
          type: 'INDIVIDUELLE',
          open: false
        })
      }
      if (this.objetpass.mois6) {
        this.itemsData.push({
          periode: this.objetpass.mois6,
          prime: this.objetpass.prime6,
          accessoire: this.objetpass.acc6,
          taxe: this.objetpass.Taxe6,
          css: this.objetpass.css6,
          primettc: this.objetpass.Ttc6,
          type: 'INDIVIDUELLE',
          open: false
        })
      }
      if (this.objetpass.mois12) {
        this.itemsData.push({
          periode: this.objetpass.mois12,
          prime: this.objetpass.prime12,
          accessoire: this.objetpass.acc12,
          taxe: this.objetpass.Taxe12,
          css: this.objetpass.css12,
          primettc: this.objetpass.Ttc12,
          type: 'INDIVIDUELLE',
          open: false
        })
      }
      clearTimeout(timer)
    },100);


    this.assureurService.ListAssreurs.subscribe(res => {
      try {
        this.assureurs = res
        // if (isUndefined(this.objetpass.CodeAssur)) {
        //   this.assureurs = res
        // }else
        // {
        //   this.assureurs = res.filter(a => (a.CodeAssu === this.objetpass.CodeAssur))
        // }
      } catch (error) {
        
      }
    })
    this._fact.seTtracking(new Date().toISOString(),
    'L5',
    false,
    '1000',
    "",
    "Prime Indiv",
    "")
 
  }

  async controlDeProvenance( _objet: any = null) {
    this.loading = await this.loadingController.create({
      message: 'Envoi en cours...',
      duration: 30000,
      mode:"ios",
      spinner: 'bubbles'
    });
    this.loading.present()
    this._fact.setData(30, [])

      //#region AUTOMOBILE and INDIVIDUELLE
        let duree = 0
        if (this.objetpass[0].periode == "3 mois") {
          duree = 90
        } else if (this.objetpass[0].periode == "6 mois") {
          duree = Math.round(this._sheard.DayOfyear(new Date) / 2)
        } else {
          duree = Math.round(this._sheard.DayOfyear(new Date))
        }
        let police=`INDI-${this._sheard.generatorPolice()}`     
        this.items = []
        this.objetpass.CodeAssur = this._fact.getData(201)
        this.items.push({
          NumPolice: police,
          police:police,
          NomPrenom: this.auth.profile.NomPrenom,
          Notification: "",
          CodeAssur: this.objetpass.CodeAssur,
          NumRef: "",
          dateEffet: this.objetpass.dateEffet,
          dateExpi: this.objetpass.dateExpi,
          montant_due: this.objetpass[0].primettc,
          montant_paye: 0,
          date_paiement: "",
          dateInsert: this._sheard.getDate(),
          etatdoc: "",
          icon:"../../../assets/icon/man.svg",
          flag: false,
          //isChecked:true,
          notifydoc: false,
          notify: true,
          CodeMvt: "AFN",
          duree: duree,
          mode_paie: "",
          numClient: "",//this.auth.profile.numClient,
          solde: false,
          type: "Individuelle",
          idKey: this.auth.profile.uid
        })
        // this._fact.setData(30,this.items[0])
        this._primeService.insertPrime(this.items).then(
          (res) => {
            this.items[0].$key = res.key
            this.items[0].nbPaie=0
            this.items[0].montantVerse=0
            this.items[0].montant_restant=this.objetpass[0].primettc
            this._fact.setData(30, this.items[0])
            // if (isUndefined(this.objetpass.CodeAssur)) {
            //   this._primeService.addQuit(res.key,this.objetpass.CodeAssur)
            //   }
            this.uploadingIndividuelle(res.key,police)

          }
        )



  }

  private uploadingIndividuelle($key: string,police) {
    this._fact.seTtracking(new Date().toISOString(),
    'L6',
    false,
    '1000',
    "",
    "Enregistrement Indiv",
    police
    )
    this._cotationIndivAccidentService.instNewIndividuelle(this.objetpass.CodeAssur, $key,police).then
      (
        () => {

          this.loading.dismiss().then(
            (res) => {
              if (res) {
                this.modalCtrl.dismiss().then(
                  (res) => {
                    if (res) {
                      this._route.navigate(['prime', 30]);
                    }
                  }
                )
              }
            }
          )

          // setTimeout(() => {

          // });

        }
      ).catch(
        (error) => console.error(error)

      ).finally(() => this.loading.dismiss())
  }

  onValider(item) {
    //this.objetpass.cartegrise=this.selectedImage
    this.desactiveBtn()
    this.presentPayment(item)
  }
  
  PayerPrimer() {

    this.controlDeProvenance(this.TypeObjet)
 
  }

  private async presentPayment(nameSelected) {

    let dateEffet = this._sheard.getDateWithTimeDMY()
    let dateExpi
    // this._sheard.TimeStampToformatDMY(this._sheard.getTimeStampFromToday())
    if (nameSelected.periode == "3 mois") {
      dateExpi = this._sheard.ConvertDMYorYMD(this._sheard.getDate(this._sheard.AddDays(
        this._sheard.getDate(),
        89
      )))
    } else if (nameSelected.periode == "6 mois") {
      dateExpi = this._sheard.ConvertDMYorYMD(this._sheard.getDate(this._sheard.AddDays(
        this._sheard.getDate(),
        Math.round(this._sheard.DayOfyear(new Date()) / 2) - 1
      )))
    } else if (nameSelected.periode == "12 mois") {
      dateExpi = this._sheard.ConvertDMYorYMD(this._sheard.getDate(this._sheard.AddDays(this._sheard.getDate(), this._sheard.DayOfyear(new Date()) - 1)))
    }



    const alert = await this.alertController.create({
      header: 'Paiement de la prime',mode:"ios",
      message: 'Vous avez choisi une couverture d\'une durée de <strong>' + nameSelected.periode +
        '</strong>. Ce contrat d\'assurance prendra donc effet à :' +
        '<p>*Date éffet <strong>' + dateEffet + '</strong></p>' +
        '<p>*Date expiration <strong>' + dateExpi + '</strong></p>' +
        '<p><strong>NB:</strong> Si vous reportez le paiement de la prime à un autre jour,' +
        'la date d\'effet sera la date de paiement </p><br>',

      buttons: [
        {
          text: 'Annuler',
          role: 'cancel',
          cssClass: 'primary',
          handler: () => {
            //this._objet = "Selectionner l'objet"

          }
        },
        {
          text: 'OK',
          handler: () => {
       
            
              this.objetpass = this.itemsData = this.itemsData.filter(e => e.periode == nameSelected.periode)
              this.textImageselect = true
            


            this.objetpass.dateEffet = dateEffet;
            this.objetpass.dateExpi = dateExpi;
            this.objetpass.duree =  nameSelected.periode


            setTimeout(() => {
              this.content.scrollToBottom(800).then(
                //() => this.affiche=true
              )
              // $("#mytext").focus();
            });



          }
        }
      ]
    });
    await alert.present();
  }
  private desactiveBtn() {
    this.isEnabled = false;
    if (this.objetpass.CodeAssur) {
      this.isEnabled = true;
    }

  }
  userChange(event: { component: IonicSelectableComponent, value: any }) {

    if (event.value) {
      this.objetpass.CodeAssur = event.value.CodeAssu
      this.desactiveBtn()
    } else {

    }

  }
}
